import { MenuType } from '@/types';

/**
 * todo: clearify the tabs for each menu
 * todo: dynamic DB should be maintained and fetch menu through api
 */
export const MENU_ITEMS: MenuType[] = [
  {
    key: '1',
    label: 'Dashboard',
    link: '/dashboard',
    icon: 'dashboard',
    display: true,
    breadcrumb: [
      {
        title: 'Dashboard',
        href: '/dashboard',
      },
    ],
  },
  {
    key: '3',
    label: 'Mortgage',
    icon: 'wallet',
    display: true,
    breadcrumb: [
      {
        title: 'Mortgage',
        href: '/mortgage',
      },
    ],
    children: [
      {
        key: '3.1',
        label: 'Purchase',
        link: '/mortgage/purchase',
        parentKey: '3',
        icon: 'purchase',
        display: true,
        breadcrumb: [
          {
            title: 'Mortgage',
            href: '/mortgage',
          },
          {
            title: 'Purchase',
            href: '/mortgage/purchase',
          },
        ],
      },
      {
        key: '3.2',
        label: 'Refinance',
        link: '/mortgage/refinance',
        parentKey: '3',
        display: true,
        icon: 'refinance',
        breadcrumb: [
          {
            title: 'Mortgage',
            href: '/mortgage',
          },
          {
            title: 'Refinance',
            href: '/mortgage/refinance',
          },
        ],
      },
      {
        key: '3.3',
        label: 'Pre-approval',
        link: '/mortgage/preapproval',
        parentKey: '3',
        display: true,
        icon: 'preapproval',
        breadcrumb: [
          {
            title: 'Mortgage',
            href: '/mortgage',
          },
          {
            title: 'Pre-approval',
            href: '/mortgage/preapproval',
          },
        ],
      },
      {
        key: '3.4',
        label: 'Settled',
        link: '/mortgage/settled',
        parentKey: '3',
        display: true,
        icon: 'settled',
        breadcrumb: [
          {
            title: 'Mortgage',
            href: '/mortgage',
          },
          {
            title: 'Settled',
            href: '/mortgage/settled',
          },
        ],
      },
    ],
  },
  {
    key: '4',
    label: 'Tax',
    display: true,
    icon: 'percent',
    breadcrumb: [
      {
        title: 'Tax',
        href: '/tax',
      },
    ],
    children: [
      {
        key: '4.1',
        label: 'Health Check',
        link: '/tax/health-check',
        parentKey: '4',
        display: true,
        icon: 'health-check',
        breadcrumb: [
          {
            title: 'Tax',
            href: '/tax',
          },
          {
            title: 'Health Check',
            href: '/tax/health-check',
          },
        ],
      },
      // {
      //   key: '4.2',
      //   label: 'Lodge Return',
      //   link: '/tax/lodge-return',
      //   parentKey: '4',
      //   display: true,
      //   icon: 'lodge-return',
      //   breadcrumb: [
      //     {
      //       title: 'Tax',
      //       href: '/tax',
      //     },
      //     {
      //       title: 'Lodge Return',
      //       href: '/tax/lodge-return',
      //     },
      //   ],
      // },
      {
        key: '4.3',
        label: 'Tax Advice',
        link: '/tax/tax-advice',
        parentKey: '4',
        display: true,
        icon: 'tax-advice',
        breadcrumb: [
          {
            title: 'Tax',
            href: '/tax',
          },
          {
            title: 'Tax Advice',
            href: '/tax/tax-advice',
          },
        ],
      },
      // {
      //   key: '4.3',
      //   label: 'Pre Approval',
      //   link: '/tax/pre-approval',
      //   parentKey: '4',
      //   display: true,
      //   icon: 'preapproval',
      // },
      // {
      //   key: '4.4',
      //   label: 'Settled',
      //   link: '/tax/settled',
      //   parentKey: '4',
      //   display: true,
      //   icon: 'settled',
      // },
      // {
      //   key: '4.5',
      //   label: 'Tax Deal Stage',
      //   link: '/tax/tax-deal-stage',
      //   parentKey: '4',
      //   display: true,
      //   icon: 'tax-deal-stage',
      // },
    ],
  },
  {
    key: '5',
    label: 'Calculators',
    link: '/calculators',
    icon: 'calc',
    display: true,
    breadcrumb: [
      {
        title: 'Calculators',
        href: '/calculators',
      },
    ],
  },
  {
    key: '8',
    label: 'Property',
    icon: 'home',
    display: true,
    breadcrumb: [
      {
        title: 'Property',
        href: '/property',
      },
    ],
    children: [
      {
        key: '8.1',
        label: 'My Properties',
        link: '/property/my-properties',
        parentKey: '8',
        display: true,
        icon: 'home',
        breadcrumb: [
          {
            title: 'Property',
            href: '/property',
          },
          {
            title: 'My Properties',
            href: '/property/my-properties',
          },
        ],
      },
      // {
      //   key: '8.2',
      //   label: 'My Watchlist',
      //   link: '/property/my-watchlist',
      //   parentKey: '8',
      //   display: true,
      //   icon: 'watchlist',
      //   breadcrumb: [
      //     {
      //       title: 'Property',
      //       href: '/property',
      //     },
      //     {
      //       title: 'My Watchlist',
      //       href: '/property/my-watchlist',
      //     },
      //   ],
      // },
      {
        key: '8.3',
        label: 'Add Australian Property',
        link: '/property/add-australian-property',
        parentKey: '8',
        display: false,
        icon: 'add',
      },
      {
        key: '8.4',
        label: 'Add Overseas Property',
        link: '/property/add-overseas-property',
        parentKey: '8',
        display: false,
        icon: 'add',
      },
    ],
  },
  {
    key: '6',
    label: 'FX',
    icon: 'swap',
    display: true,
    breadcrumb: [
      {
        title: 'FX',
        href: '/fx',
      },
    ],
    children: [
      {
        key: '6.1',
        label: 'OFX',
        link: '/fx/ofx',
        parentKey: '6',
        display: true,
        icon: 'ofx',
        breadcrumb: [
          {
            title: 'FX',
            href: '/fx',
          },
          {
            title: 'OFX',
            href: '/fx/ofx',
          },
        ],
      },
      {
        key: '6.2',
        label: 'TORFX',
        link: '/fx/torfx',
        parentKey: '6',
        display: true,
        icon: 'torfx',
        breadcrumb: [
          {
            title: 'FX',
            href: '/fx',
          },
          {
            title: 'TORFX',
            href: '/fx/torfx',
          },
        ],
      },
    ],
  },
  // {
  //   key: '9',
  //   label: 'Conveyancing',
  //   icon: 'building',
  //   display: true,
  //   breadcrumb: [
  //     {
  //       title: 'Conveyancing',
  //       href: '/conveyancing',
  //     },
  //   ],
  //   children: [
  //     {
  //       key: '9.1',
  //       label: 'Get Quote',
  //       link: '/conveyancing/quote',
  //       parentKey: '9',
  //       display: true,
  //       icon: 'preapproval',
  //     },
  //     {
  //       key: '9.2',
  //       label: 'Engagements',
  //       link: '/conveyancing/engagements',
  //       parentKey: '9',
  //       display: true,
  //       icon: 'preapproval',
  //     },
  //     {
  //       key: '9.3',
  //       label: 'Book a Meeting',
  //       link: '/conveyancing/book-meeting',
  //       parentKey: '9',
  //       display: true,
  //       icon: 'preapproval',
  //     },
  //   ],
  // },
];
